export default __webpack_public_path__ + "6f3c119a0739b8c1c43638d5fae929cc.png";